import Groups from "./Groups"

export default  Groups;



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SelectableVehicles/Groups/index.js